import styles from './order-overview-dialog.module.scss';
import { useGetRequestNewHook, useMakeRequestHook } from '../../requestUtils';
import { GetCurrentCompany } from '../../customer-context/customer-context';
import { useContext } from 'react';
import { ContractHistory, Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, SnackBarContext } from '@frontend-workspace/react-shared-lib';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface OrderOverviewDialogProps {
  open: boolean,
  onClose: () => void
}

export function OrderOverviewDialog(props: OrderOverviewDialogProps) {
  const currentCompany = GetCurrentCompany();
  const makeRequest = useMakeRequestHook();
  const { data, getData } = useGetRequestNewHook(`companies/${currentCompany?.number}/orders`, []);
  const { setSnackbarMessage } = useContext(SnackBarContext);
  const { t } = useTranslation();

  const handleDeleteOrder = (id: string) => {
    makeRequest(`orders/${id}`, "DELETE").then(() => {
      setSnackbarMessage({ content: t("orderOverview.orderDeleted"), type: "success" });
      getData();
    }).catch(() => setSnackbarMessage({ content: t("orderOverview.couldNotDeleteOrder"), type: "error" }));
  };
  const handleReasonChange = (id: string, reason: string) => {
    makeRequest(`orders/${id}/action/setSaleReason`, "PUT", { orderId: id, reason: reason }).then(() => getData())
      .catch(() => setSnackbarMessage({ content: "Kunne ikke endre årsak.", type: "error" }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth={false}
      fullWidth>
      <DialogTitle className='mb-4'>
        {t("standard.orderOverview")}
      </DialogTitle>
      <DialogContent>
        {data.length > 0 && <ContractHistory
          orders={data}
          reasonsForChange={[]}
          onReasonChange={handleReasonChange}
          onDeleteOrder={handleDeleteOrder}
        />}
      </DialogContent>
      <DialogActions>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          OK
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default OrderOverviewDialog;